import axios from 'axios';

/**
 * 获取补漏记录
 */
export const getCollectionInsertLogs = (params) => {
  return axios.get('/api/collectionInsertLogs', { params });
};

/**
 * 批量删除补漏记录
 */
export const bulkDeleteCollectionInsertLogs = (params) => {
  const { ids } = params;
  return axios.post('/api/collectionInsertLogs/bulk-delete', { ids });
};
